import { hideModal } from 'managers/modal'
import { useTranslation } from 'react-i18next'
import { Input } from 'components/ui/Input'
import { useFormik } from 'formik'
import { formFieldProps } from 'utils/form'
import { createValidationSchema, requiredEmail } from 'utils/validations'
import { UIButton } from 'components/ui/Button'
import { KeyboardEvent, useState } from 'react'
import { showSuccessToast } from 'utils/toast'
import { useSelector } from 'react-redux'
import { messagesSelectors } from 'store/messages'
import { exportChat } from 'api/chats'
import { settingsSelectors } from 'store/settings'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type ExportChatModalProps = {
  onSuccess?: () => void
}

export const ExportChatModal = ({ onSuccess }: ExportChatModalProps) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const chatId = useSelector(messagesSelectors.chatId)
  const currentUser = useSelector(settingsSelectors.userDetails)

  const { values, errors, setFieldValue, setFieldError, handleSubmit } = useFormik({
    initialValues: {
      email: currentUser?.email || '',
    },
    validationSchema: createValidationSchema({
      email: requiredEmail,
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      console.debug({ values })
      if (!chatId) {
        return
      }
      try {
        setLoading(true)
        await exportChat(chatId, values.email)
        onSuccess?.()
        showSuccessToast(t('chatExportedSuccess'))
        hideModal()
      } catch (e) {
        console.error({ e })
      } finally {
        setLoading(false)
      }
    },
  })

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  const fieldProps = formFieldProps(errors, values, setFieldError, setFieldValue)

  return (
    <div style={{ padding: 20 }}>
      <div className={'tw-flex tw-flex-row tw-items-center tw-justify-between'}>
        <div className={'tw-font-[800]'}>{t('exportChat')}</div>
        <div className={'tw-cursor-pointer'}>
          <FontAwesomeIcon icon={['far', 'times']} onClick={hideModal} />
        </div>
      </div>
      <div className={'tw-flex tw-flex-col tw-space-y-1 tw-mt-2'}>
        <Input type={'email'} label={t('email')} {...fieldProps('email')} onKeyDown={onKeyDown} />
        <div className={'tw-h-2'} />
      </div>
      <div className={'tw-mt-6 tw-w-full'}>
        <UIButton className={'tw-w-full'} onClick={() => handleSubmit()} loading={loading}>
          <span className={'tw-text-sm'}>{t('exportChat')}</span>
        </UIButton>
      </div>
    </div>
  )
}
